import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { RfpProOfferViewSkeleton } from '@/components/pages/rfp/professional/RfpProOfferView/RfpProOfferViewSkeleton';
import Layout from '@/container/Layout';
/**
 * 提案入力関連画面のスケルトン表示
 * NOTE: Layout コンポーネント TS化後 RfpProOfferViewSkeleton と統合予定
 */
export const RfpProOfferSkeleton = () => (_jsx(Layout, Object.assign({ mainClassName: 'l-main' }, { children: _jsx(RfpProOfferViewSkeleton, {}) })));
